import ResizerPkg from 'react-image-file-resizer';

import logError from '../logError';

// Vite CJS interop double-wraps this lib in prod bundle — unwrap defensively.
const imageFileResizer = ResizerPkg.imageFileResizer ?? ResizerPkg.default?.imageFileResizer;

// A case picture is read on screen, never printed, so it is resized before it
// leaves the browser: an oversized upload is refused by the API, and a refusal
// on the media path is what trips the nginx ban on a legitimate user. Same
// scheme and same targets as the end-user app (utils/compressImage.js there),
// so both sides of a case store alike — one pass resizes, turns and encodes.
const MAX_SIDE = 1920;
const MAX_SIZE_KB = 500;

const compressCasePicture = async (file, { rotation = 0 } = {}) => {
  const resize = (quality) => new Promise((resolve) => {
    imageFileResizer(
      file, // The image file to resize
      MAX_SIDE, // maxWidth
      MAX_SIDE, // maxHeight
      'webp', // compressFormat
      quality,
      rotation,
      (uri) => resolve(uri), // responseUriFunc
      'file',
    );
  });

  try {
    let picture;
    let quality = 85;

    do {
      picture = await resize(quality);

      if ((picture.size / 1024) <= MAX_SIZE_KB) break;

      quality -= 10;
    } while (quality > 20);

    return picture;
  } catch (error) {
    logError(
      `compressCasePicture ${error?.message ?? error}`,
      'compressCasePicture.error',
      {
        fileSizeMB: file?.size / 1024 / 1024,
        fileType: file?.type,
      },
    );
    return null;
  }
};

export default compressCasePicture;
